import { useEffect, useState } from "react";

const getIsDocumentVisible = () => {
    if (typeof document === 'undefined') {
        return true;
    }

    return document.visibilityState === 'visible' && document.hasFocus();
};

const useDocumentVisibility = () => {
    const [isDocumentVisible, setIsDocumentVisible] = useState(getIsDocumentVisible);

    useEffect(() => {
        if (typeof document === 'undefined') {
            return undefined;
        }

        const updateVisibility = () => {
            setIsDocumentVisible(getIsDocumentVisible());
        };

        document.addEventListener('visibilitychange', updateVisibility);
        window.addEventListener('focus', updateVisibility);
        window.addEventListener('blur', updateVisibility);

        return () => {
            document.removeEventListener('visibilitychange', updateVisibility);
            window.removeEventListener('focus', updateVisibility);
            window.removeEventListener('blur', updateVisibility);
        };
    }, []);

    return isDocumentVisible;
};

export default useDocumentVisibility;
